import { forwardRef, useEffect, useState } from "react";
import { WidgetProps, WidgetRef } from "../../../types/widget";
import { styles } from "../styles";
import { useThemeStore } from "../../../stores";
import { Column, Row } from "../../containers";
import { Heading } from "../../typography";
import { PieChart } from "@mui/x-charts";
import ChartLegend from "../../chart-legend";
import { AlignItems } from "../../containers/types";
import { CSCData } from "./types";
import Api from "../../../api/api";

const CSCInfo = [
    {
        color: "#C62828",
        label: "چک های دریافتی",
    },
    {
        color: "#283593",
        label: "چک های ثبت شده ",
    },
    {
        color: "#6A1B9A",
        label: "چک های تحویل مدیر ",
    },
    {
        color: "#00695C",
        label: "چک های خرج شده ",
    },
    {
        color: "#F9A825",
        label: " دریافت نقدی",
    },
    {
        color: "#0277BD",
        label: "مخارج نقدی",
    },
]

const ChequeStatsWidget = forwardRef<WidgetRef, WidgetProps>((props, ref) => {
    const theme = useThemeStore(s => s.theme);

    const [data, setData] = useState<CSCData>({
        nr_confirmed_cheques: 0,
        nr_delivered_cheques: 0,
        nr_rcvd_cash: 0,
        nr_rcvd_cheques: 0,
        nr_spent_cash: 0,
        nr_spent_cheques: 0,
    });

    useEffect(() => {
        Api.getData<CSCData>("/widget/cheque_stat_chart").then(res => {
            setData(res);
        }).catch(err => {
            console.log(err);
        })
    }, [])

    return (
    <div
      ref={ref}
      style={{
        background: theme.overlay,
        position: "relative",
        ...styles.container,
      }}
    >
        <Row>
            <Heading color={theme.textOnOverlay} >آمار چک ها</Heading>
        </Row>

        <Row gap={15} className="csc-con" >
            <Row>
                <PieChart
                    series={[
                        {
                            data: [
                                { id: 0, value: data.nr_rcvd_cheques, label: CSCInfo[0].label, color: CSCInfo[0].color },
                                { id: 1, value: data.nr_confirmed_cheques, label: CSCInfo[1].label, color: CSCInfo[1].color },
                                { id: 2, value: data.nr_delivered_cheques, label: CSCInfo[2].label, color: CSCInfo[2].color },
                                { id: 3, value: data.nr_spent_cheques, label: CSCInfo[3].label, color: CSCInfo[3].color },
                                { id: 4, value: data.nr_rcvd_cash, label: CSCInfo[4].label, color: CSCInfo[4].color },
                                { id: 5, value: data.nr_spent_cash, label: CSCInfo[5].label, color: CSCInfo[5].color },
                            ],
                            innerRadius: 30,
                            outerRadius: 100,
                            paddingAngle: 5,
                            cornerRadius: 5,
                            startAngle: -45,
                            endAngle: 225,
                            cx: 80
                        }
                    ]}
                    sx={() => ({
                        ".MuiPieArc-root": {
                            stroke: "none"
                        }
                    })}
                    slotProps={{legend: {hidden: true}}}
                    width={200}
                    height={200}
                />
            </Row>
            <Column gap={10} alignItems={AlignItems.Start} >
                {CSCInfo.map(info => (
                    <ChartLegend color={info.color} label={info.label} key={info.color} />
                ))}
            </Column>
        </Row>
    </div>
    )
})

export default ChequeStatsWidget;